const initialState = {
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_STORY_SUCCESS':
      return action.payload.story;
    case 'STORY_TOGGLE_SUBSCRIBE_SUCCESS':
      return Object.assign({}, state, {subscribed: !state.subscribed});
    default:
      return state;
  }
};